import { useEffect } from "react";
import FilterValueProps from "types/FilterValueProps";

interface useSelectedOptionsProps{
  options: Array<FilterValueProps>
  selectedOptions: Array<FilterValueProps>
  onSelectValue: Function
  name: string
  param: string
  isMulti: boolean
  selectAllOptionsLabel?: string
  selectAllOptionsValue?: string
}

const useSelectedOptions = (props: useSelectedOptionsProps) => {
  useEffect(() => {
    //handle empty selected options of the filter or multiselects
    if(props.selectedOptions.length === 0 || props.isMulti){

      const selectAllMultipleReplacement = props.isMulti && props.selectedOptions?.length > 0 && props.selectedOptions?.length === props.options?.length
      
      const label = (![undefined, null, ''].includes(props.selectAllOptionsLabel) && selectAllMultipleReplacement)
      ? props.selectAllOptionsLabel
      : (props.selectedOptions.length === 0 ? props.name : props.selectedOptions.map(o => o.label).join(', '))
      
      const value = (![undefined, null, ''].includes(props.selectAllOptionsValue) && selectAllMultipleReplacement)
      ? props.selectAllOptionsValue
      : (props.selectedOptions.length === 0 ? '' : props.selectedOptions.map(o => o.value))
      props.onSelectValue(props.param, value, label);
    }
  }, [props.selectedOptions])
}


export default useSelectedOptions 